module.exports = __webpack_public_path__ + "static/img/hs-dj.0b3ae259.png";